import { render, staticRenderFns } from "./VideoChapter.vue?vue&type=template&id=1d0bf4e8&"
import script from "./VideoChapter.vue?vue&type=script&lang=js&"
export * from "./VideoChapter.vue?vue&type=script&lang=js&"
import style0 from "./VideoChapter.vue?vue&type=style&index=0&id=1d0bf4e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports